var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPallets = function SvgPallets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    d: "M2 19h20M5 19v2M12 19v2M19 19v2M18.77 11h-5.54c-.679 0-1.23.551-1.23 1.23v5.54c0 .679.551 1.23 1.23 1.23h5.54c.679 0 1.23-.551 1.23-1.23v-5.54c0-.679-.551-1.23-1.23-1.23M10.77 11H5.23C4.552 11 4 11.551 4 12.23v5.54c0 .679.551 1.23 1.23 1.23h5.54c.679 0 1.23-.551 1.23-1.23v-5.54c0-.679-.551-1.23-1.23-1.23M14.77 3H9.23C8.552 3 8 3.551 8 4.23v5.54c0 .679.551 1.23 1.23 1.23h5.54c.679 0 1.23-.551 1.23-1.23V4.23C16 3.552 15.449 3 14.77 3M15 16h2M7 16h2M11 8h2"
  })));
};
export default SvgPallets;